<template>
    <div id="direction">
        <bread :content="breadContent"></bread>
        <p class="Page-title">研究方向</p>
        <el-divider></el-divider>
        <!--Article-- :html="content"></!--Article-->
        <p class="mes" v-html="content"></p>
        <!--div-- class="time">最后编辑时间：{{ editTime }}</!--div-->
    </div>
</template>
<script>
import bread from "@/components/bread";

export default {
  name: "direction",
  components: {
    bread,
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心概况", routerName: "introduce" },
        { text: "科学研究", routerName: "direction" },
        { text: "研究方向", routerName: "direction" }
      ],
      content: '',
      editTime: '',
    }
  },
  async created() {
    const res = await this.$net.introduce.getDirection()
    this.content = res.Content
    this.editTime = res.AdminSetTime
  }
}
</script>
  
<style lang="scss" scoped>
#direction {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.second-title{
  color:#333333;
  font-size: 20px;
  font-weight: 700;
}
.mes{
  font-weight: 400;
  line-height: 32px;
  margin-bottom: 25px;
}
.time {
  margin-top: 60px;
  color: #909399;
  text-align: right;
}
</style>
